import { dynamicsEnvironment, env } from '@/lib/env'
import { useTokenStore } from '@/lib/store'
import axios from 'axios'
import { applyDataverseWriteContract } from './dataverse-write-contract'
import { attachResponseInterceptor } from './interceptors'

export type EntityLogicalName =
  | 'accounts'
  | 'contacts'
  | 'dsy_accountrooms'
  | 'dsy_quotedetailtemplates'
  | 'opportunities'
  | 'dsy_pricelistitems'
  | 'products'
  | 'dsy_pricelistitemaccessories'
  | 'dsy_productaccessories'
  | 'quotedetails'
  | 'dsy_lineitemcpqfieldses'
  | 'quotes'
  | 'systemusers'
  | 'pricelevels'
  | 'dsy_branchs'
  | 'msdyn_taxcodes'
  | 'dsy_paymentmilestones'
  | 'salesorders'
  | 'salesorderdetails'
  | 'dsy_manufacturers'
  | 'dsy_ns_inventorybalances'
  | 'environmentvariabledefinitions'
  | 'emailsignatures'
  | 'emails'
  | 'activitymimeattachments'
  | 'annotations'
  | 'mailboxes'

export const dynamicsApi = axios.create({
  baseURL: env.VITE_DYNAMICS_API_BASE_URL + '/api/data/v9.2',
})

dynamicsApi.interceptors.request.use(async (config) => {
  applyDataverseWriteContract(config)
  const token = await useTokenStore.getState().getToken()
  config.headers.Authorization = `Bearer ${token.accessToken}`
  return config
})

export const proposalApi = axios.create({
  baseURL: env.VITE_PROPOSAL_API_BASE_URL + '/api',
})

proposalApi.interceptors.request.use(async (config) => {
  config.headers['X-Dynamics-Environment'] = dynamicsEnvironment
  // Send MSAL token for authenticated users (internal routes)
  try {
    const token = await useTokenStore.getState().getToken()
    if (token?.accessToken) {
      config.headers.Authorization = `Bearer ${token.accessToken}`
    }
  } catch {
    // No token available — client-facing route, no auth needed
  }
  return config
})

export const integrationsApi = axios.create({
  baseURL: env.VITE_PROPOSAL_API_BASE_URL + '/api/integrations',
})

// Auth-only. proposal-api injects the integrations function key server-side.
integrationsApi.interceptors.request.use(async (config) => {
  config.headers['X-Dynamics-Environment'] = dynamicsEnvironment
  const token = await useTokenStore.getState().getToken()
  config.headers.Authorization = `Bearer ${token.accessToken}`
  return config
})

attachResponseInterceptor(dynamicsApi)
attachResponseInterceptor(proposalApi)
attachResponseInterceptor(integrationsApi)
